// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3cCZm","modalFooterButton":"ModalNotes_modalFooterButton__28Xoo"};